var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 57,
    viewBox: "0 0 76 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7133 21.9687C6.81004 24.0469 0 29.9844 0 39.1875C0 50.1719 8.17204 57 17.9785 57C28.0573 57 36.2294 48.3906 36.2294 37.4062C36.2294 17.2188 22.3369 3.26562 8.44444 0L5.72043 5.34375C19.0681 10.9844 18.2509 18.7031 11.7133 21.9687ZM51.4839 21.9687C46.5806 24.0469 39.7706 29.9844 39.7706 39.1875C39.7706 50.1719 47.9427 57 58.0215 57C68.1004 57 76 48.3906 76 37.4062C76 17.2188 62.3799 3.26562 48.4875 0L45.491 5.34375C58.8387 10.9844 58.2939 18.7031 51.4839 21.9687Z",
    fill: "#101828",
    fillOpacity: 0.03
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.51c8cdd75fa990ea5abb4073cd599d5e.svg";
export { ForwardRef as ReactComponent };